import * as React from 'react';
import QuoteNPM from '@rotaryintl/harris-quote';
import { Text } from '@sitecore-jss/sitecore-jss-react';

export default function Quote({ params: { ComponentId } = {}, fields = {} }) {
  const quote = fields?.Quote;
  const authorName = fields?.AuthorName?.value;
  const authorTitle = fields?.AuthorTitle?.value;
  const authorImage = fields?.AuthorImage?.value;

  const avatar = authorImage?.src
    ? {
        children: <img src={authorImage.src} alt={authorImage.alt || authorName || 'Author'} />,
      }
    : undefined;

  return <QuoteNPM id={ComponentId} text={<Text field={quote} />} authorName={authorName} authorTitle={authorTitle} avatar={avatar} />;
}
